export const secretKey = '0000';